var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSunrise(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_84",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1577 9.94615L17.1039 8.86155L19.0423 6.95388L20.0961 8.0077L18.1577 9.94615ZM2.25003 19.75V18.25H21.75V19.75H2.25003ZM11.25 7.1154V4.4231H12.75V7.1154H11.25ZM5.84233 9.91538L3.93466 7.97693L4.98848 6.9231L6.92691 8.86155L5.84233 9.91538ZM7.42501 14H16.575C16.1917 13.1 15.5901 12.375 14.7702 11.825C13.9503 11.275 13.0269 11 12 11C10.9731 11 10.0497 11.275 9.22981 11.825C8.40994 12.375 7.80834 13.1 7.42501 14ZM5.55773 15.5C5.67313 13.8 6.34749 12.375 7.58081 11.225C8.81414 10.075 10.2872 9.50003 12 9.50003C13.7128 9.50003 15.1859 10.075 16.4192 11.225C17.6525 12.375 18.3269 13.8 18.4423 15.5H5.55773Z",
    fill: "#1C1B1F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunrise);
export default __webpack_public_path__ + "static/media/sunrise.5b1f9a7d3ef713cdc62f3e05f218af71.svg";
export { ForwardRef as ReactComponent };